// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9d874e79","818":"00183aac"}[chunkId] + ".chunk.js";
};